import api from './api';

export interface FluxoProcesso {
  id: string;
  descricaoEtapa: string;
  codigoEtapa: string;
}

export interface FluxoProcessoOptions{
  text: string;
  value: string;
}

export const getAllFluxoProcessoEtapa = () => api.get<FluxoProcesso[]>('FluxoProcesso');
export const getBidFluxoProcessoEtapa = (idPai:string) => api.get<string[]>(`FluxoProcesso/${idPai}`);